<script lang="ts">
  import { IntersectionObserver } from "@opera-gx/components/v6";
  // prettier-ignore
  import { fly } from "svelte/transition";

  import Tile from "../components/Tile/Tile.svelte";
  import * as eneba from "../store/eneba";
  export let index;
  export let deal;
  const platforms = eneba.getPlatforms(deal.platform);
</script>

<div
  class="aspect-[3/4] w-auto transition-all duration-700"
  style="transition-delay: {40 * index}ms;">
  <IntersectionObserver once={true} let:intersecting>
    {#if intersecting}
      <Tile let:class={tile}>
        <a
          href={deal.url_store}
          class="{tile} to-accent/40 after:to-accent relative block aspect-[3/4] bg-gradient-to-br from-transparent bg-cover bg-center bg-no-repeat after:bg-gradient-to-br after:from-transparent after:via-transparent"
          style="background-image: url({deal.thumbnail_file})"
          target="_blank"
          transition:fly
          class:-translate-x-3={!intersecting}>
          <div
            style="background-color: {eneba.defaultColor}; display: flex; align-items: center; padding-left: 2px; padding-right: 2px;"
            class="bg-accent text-shadow absolute right-4 top-0 h-7 w-5 rounded-b text-white">
            <img src={eneba.defaultIcon} alt="Store img" />
          </div>
          <div
            class="text-shadow absolute bottom-2 left-2 flex w-full flex-col items-start gap-1 text-white">
            <div class="w-11/12 truncate text-sm font-semibold leading-none">
              {deal.title}
            </div>
            {#if deal?.platform}
              <div class="flex flex-row gap-1">
                {#each platforms as platform}
                  <img
                    src={eneba.getIcons(platform)}
                    alt="platform"
                    class="h-4 w-4 rounded-full bg-[#CFCFCF] text-[#131019]" />
                {/each}
              </div>
            {/if}
            <div class="flex flex-row items-center gap-1">
              {#if deal.discounted_price && deal.discounted_percentage}
                <div
                  class="bg-accent text-2xs rounded px-1.5 py-1 font-bold uppercase italic">
                  {deal.discounted_percentage}
                </div>
                <div class="text-xs font-semibold uppercase">
                  {deal.discounted_price}
                </div>
              {/if}
            </div>
          </div>
        </a>
      </Tile>
    {/if}
  </IntersectionObserver>
</div>
